export const MICROSCOPIA_FINALIZADA = 'MICROSCOPIA_FINALIZADA';
export const microscopiaFinalizada = (microscopiaFinalizada) => ({
  type: MICROSCOPIA_FINALIZADA,
  payload: {
    microscopiaFinalizada: microscopiaFinalizada,
  },
});



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/microscopia/microscopia.action.js